import React, { useEffect, useState } from "react";
import ReactPlayer from "react-player";
import Loadable from "@loadable/component";
import { Link } from "gatsby";
import { firestore } from "../../utils/firebase";

// Styles
import "../../assets/css/youtubeBanner.css";

const OwlCarousel = Loadable(() => import("react-owl-carousel3"));

const options = {
  loop: true,
  nav: true,
  dots: false,
  autoplayHoverPause: true,
  autoplay: true,
  items: 1,
  navText: [
    "<i class='flaticon-left-1'></i>",
    "<i class='flaticon-right-1'></i>",
  ],
};

const Youtube = () => {
  const [youtubeURL, setYoutubeURL] = useState(
    "https://www.youtube.com/watch?v=Tmoh7mqpbSo"
  ); // default youtube url

  // FetchData
  useEffect(() => {
    firestore
      .collection("Config")
      .doc("A517Kmz7SqcTY9neMVuM")
      .onSnapshot((doc) => {
        console.log(doc.id);
        if (doc.exists) {
          let data = doc.data();

          for (var key in data) {
            setYoutubeURL(data[key]);
          }
        }
      });
  });

  return (
    <div className="container">
      {/* <p className="text-center"> Jr.Hackathon 2021 @Peel </p> */}
      <div className="player-wrapper">
        <ReactPlayer
          url={youtubeURL} // get it form
          className="react-player"
          playing
          width="100%"
          height="100%"
          controls={true}
        />
      </div>

      <h3 className="text-center mt-3 ">New classes starting May 01</h3>
      <div className="btn-box text-center">
        <Link to="/Register" className="default-btn">
          <i className="flaticon-right"></i>
          Register Today! <span></span>
        </Link>
      </div>
    </div>
  );
};

// Exporting Component
export default Youtube;
